var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.value
      ? _c("p", { staticStyle: { color: "green" } }, [
          _vm._v(_vm._s(_vm.trueText))
        ])
      : _vm._e(),
    !this.value
      ? _c("p", { staticStyle: { color: "red" } }, [
          _vm._v(_vm._s(_vm.falseText))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }